module.exports = __webpack_public_path__ + "fonts/Vonnes-MediumComp.6ea1274e.otf";